import { useState } from 'react';

export interface SelectionOptions {
    rows: any[];
    selectedKeys?: any[];
    getKey?: (row: any) => any;
}

export interface UseSelectionsHook {
    selectedKeys: any[];
    selectAll: boolean;
    toggleAll: () => any[];
    toggleSelection: (key: any, shiftKeyPressed: boolean, row: any) => any[];
    selectType?: "checkbox" | "radio";
}

function getKeyDefault(row: any) {
    return row.id;
}
// function isSelectedDefault(row: any, selectedIDs: any[]) {
//     return selectedIDs.includes(getKeyDefault(row)) || !!(row.selected);
// }

export function useSelections(options: SelectionOptions): UseSelectionsHook {

    const rows = options.rows;
    const getKey = options.getKey || getKeyDefault;
    const selectedKeys = options.selectedKeys || [];

    const [selectAll, setSelectAll] = useState(false);

    function toggleSelection(key: any, shiftKeyPressed: boolean, row: any): any[] {
        let newSelections = [...selectedKeys];
        const keyIndex = newSelections.indexOf(key);
        // check to see if the key exists
        if (keyIndex >= 0) {
            // it does exist so we will remove it using destructing
            newSelections = [
                ...newSelections.slice(0, keyIndex),
                ...newSelections.slice(keyIndex + 1)
            ];
        } else {
            // it does not exist so add it
            newSelections.push(key);
        }
        // update the state
        return newSelections;
    };

    function toggleAll(): any[] {
        const newSelectAll = !selectAll;
        let newSelections: any[] = [];

        if (newSelectAll) {
            // we just push all the IDs onto the selection array
            newSelections = rows.map(row => getKey(row));
        }
        setSelectAll(newSelectAll);
        return newSelections;
    };


    return {
        selectedKeys,
        selectAll,
        toggleAll, 
        toggleSelection,
        selectType: 'checkbox'
    }
}